import { Select } from "components/shared/form";
import React from "react";
import { components } from "react-select";
import { get as partyLookups } from "sources/partyLookup";

const partyLookupComponents = {
    Option: (props) => {
        const { name, inn } = props.data.option;
        return (
            <components.Option {...props}>
                {name} <small className="text-muted">ИНН: {inn}</small>
            </components.Option>
        );
    },
};

export default function PartyLookup({ onSelect }) {
    return (
        <Select
            label="Название или ИНН"
            inputProps={{ name: "nameOrInn" }}
            url={partyLookups}
            propName="name"
            menuPortalTarget={document.body}
            minimumInputLength={2}
            idKey="inn"
            onChange={onSelect}
            filterOption={(option, search) => {
                if (!option.label) {
                    return false;
                } else {
                    return search
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (item) =>
                                option.label.toLowerCase().indexOf(item) > -1 ||
                                option.value.toLowerCase().indexOf(item) > -1,
                        );
                }
            }}
            components={partyLookupComponents}
        />
    );
}
